import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const useLegacyWikiEnabled = (): boolean =>
  useApi(configApiRef).getOptionalBoolean('legacyWiki.enabled') ?? false;
